
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { api, staticpageUploadDir } from '../../config';
import s from './Page.css';

class Page extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    html: PropTypes.string.isRequired,
  };

  render() {
    const { title, html, pageBanner } = this.props;
    return (
      <div className={s.bgPadding}>
        {
          pageBanner && <div
            className={cx(s.backGroungImg, 'backGroungImgDark')}
            style={{ backgroundImage: `url(${api.apiEndpoint + staticpageUploadDir + pageBanner})` }} />
        }
        <div className={s.containerWith}>
          <div className={cx(s.staticContainer, 'textAlignRightRTL')}>
            {title && <h1>{title}</h1>}
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </div>
    );
  }
}
export default withStyles(s)(Page);